<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="rows"
      class="elevation-1 ma-0 tableCust2"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on }">
              <v-btn-toggle dense>
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 primary"
                  v-on="on"
                  @click="newItem"
                  :disabled="seriesSelected ? false : true"
                >
                  <v-icon left dark>fa-plus</v-icon>
                  {{ $t("common.form.add") }}
                </v-btn>
                &nbsp;&nbsp;
                <v-btn
                  color="primary"
                  dark
                  class="mb-2 primary"
                  v-on="on"
                  @click="importItem"
                  :disabled="seriesSelected ? false : true"
                >
                  <v-icon left dark>far fa-file-import</v-icon>
                  {{ $t("common.form.import") }}
                </v-btn>
              </v-btn-toggle>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-form ref="formSC" class="pt-4 inputSeries">
                  <v-row>
                    <v-col cols="12">
                      <!-- IMPORT -->
                      <v-radio-group
                        v-if="editorType == 'import'"
                        v-model="importSeriesClassesFrom"
                        mandatory
                        row
                      >
                        <v-radio :label="$t('page.series.seriesRadioLbl')" @change="getSeries" value="series"></v-radio>
                        <v-radio :label="$t('page.series.eventsRadioLbl')" @change="getEvents" value="events"></v-radio>
                        <v-radio :label="$t('page.series.organizationRadioLbl')" @change="getOrganizations" value="organization"></v-radio>
                      </v-radio-group>
                      <v-autocomplete
                        v-if="editorType == 'import' && importSeriesClassesFrom == 'series'"
                        v-model="seriesModel"
                        :items="seriesItems"
                        ref="selectSeriesInput"
                        small-chips
                        deletable-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.series-required'),
                        ]"
                        @keyup.enter="importClasses"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-if="editorType == 'import' && importSeriesClassesFrom == 'events'"
                        v-model="eventsModel"
                        :items="eventsItems"                        
                        ref="selectEventsInput"
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.events-required'),
                        ]"
                        @keyup.enter="importClasses"
                      ></v-autocomplete>
                      <v-autocomplete
                        v-if="editorType == 'import' && importSeriesClassesFrom == 'organization'"
                        v-model="organizationModel"
                        :items="organizationItems"
                        ref="selectOrganizationInput"
                        chips
                        deletable-chips
                        small-chips
                        outlined
                        dense
                        required
                        :rules="[
                          (v) => !!v || $t('page.series.organization-required'),
                        ]"
                        @keyup.enter="importClasses"
                      ></v-autocomplete>
                      <!-- END IMPORT -->
                      
                      <v-text-field
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="input.class"
                        ref="inputclass"
                        :label="$t('page.series.class-name')"
                        required
                        outlined
                        dense
                        :rules="[
                          () => $inputRules({value: input.class}, 'filled') || $t('page.series.className-required'),
                          () => $inputRules({value: input.class, minSize: 1, maxSize: 200}, 'fieldLength') || $t('page.series.className-required')
                        ]"
                        @keyup.enter="pressEnter"
                      ></v-text-field>
                      <v-select
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="input.group"
                        :items="input.groupItems"
                        item-text="text"
                        item-value="value"
                        ref="groupItems"
                        :label="$t('page.series.group-name')"
                        outlined
                        dense
                        required
                        @keyup.enter="pressEnter"
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                      <v-text-field
                        v-if="editorType == 'new' || editorType == 'edit'"

                        v-model="input.throwAways"
                        ref="inputthrowaway"
                        :label="$t('page.series.throw-away')"
                        required
                        outlined
                        dense
                        :rules="[
                          (v) => !$inputRules({value: v || ''}, 'filled') || $inputRules({value: v}, 'integer') || $t('page.series.throwAways-invalid')
                        ]"
                        @keyup.enter="pressEnter"
                      ></v-text-field>
                      <v-select
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="input.applyThrowToOverall"
                        :items="disableForSeriesItems"
                        item-text="text"
                        item-value="id"
                        ref="applyThrowToOverallItems"
                        :label="$t('page.series.apply-throw-to-overall')"
                        outlined
                        dense
                        required
                        :rules="[
                          (v) =>
                            v == 1 ||
                            v == 0 ||
                            $t('page.series.applyThrowToOverall-required'),
                        ]"
                        @keyup.enter="pressEnter"
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                      <v-select
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="input.disableForSeries"
                        :items="disableForSeriesItems"
                        item-text="text"
                        item-value="id"
                        ref="disableForSeriesItems"
                        :label="$t('page.series.disable-for-series')"
                        outlined
                        dense
                        required
                        :rules="[
                          (v) =>
                            v == 1 ||
                            v == 0 ||
                            $t('page.series.disableForSeries-required'),
                        ]"
                        @keyup.enter="pressEnter"
                        :no-data-text="$t('common.no_data')"
                      ></v-select>
                      <v-text-field
                        v-model="input.eventsToCount"
                        ref="inputeventstocount"
                        :label="$t('page.series.events-to-count')"
                        required
                        outlined
                        dense
                        :rules="[
                          (v) => $inputRules({value: v, minValue: 0, maxValue: 500}, 'numericBetween') || $t('page.series.eventsToCount-invalid')
                        ]"
                        @keyup="($event) => pressEnterDefaultZero($event,'eventsToCount')"
                        @keyup.enter="pressEnter"
                      ></v-text-field>
                      <v-text-field
                        v-if="editorType == 'new' || editorType == 'edit'"
                        v-model="input.sortOrder"
                        ref="inputsortorder"
                        :label="$t('page.series.sort-order')"
                        required
                        outlined
                        dense
                        :rules="[
                          (v) => $inputRules({value: v}, 'integer') || $t('page.series.sortOrder-invalid')
                        ]"
                        @keyup.enter="pressEnter"
                      ></v-text-field>
                      <v-text-field
                        v-if="editorType == 'import'"

                        v-model="input.throwAways"
                        ref="inputthrowaway"
                        :label="$tc('page.series.throw-away')"
                        required
                        outlined
                        dense
                        :rules="[
                          (v) => $inputRules({value: v, minValue: 0, maxValue: 500}, 'numericBetween') || $t('page.series.throwAways-invalid')
                        ]"
                        @keyup="($event) => pressEnterDefaultZero($event,'throwAways')"
                        @keyup.enter="pressEnter"
                      ></v-text-field>

                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" small text @click="close">{{
                  $t("common.form.cancel")
                }}</v-btn>
                <v-btn
                  v-if="editorType == 'new'"
                  color="blue darken-1"
                  small
                  text
                  @click="create"
                  >{{ $t("common.form.create") }}</v-btn
                >
                <v-btn
                  v-if="editorType == 'edit'"
                  color="blue darken-1"
                  small
                  text
                  @click="save"
                  >{{ $t("common.form.update") }}</v-btn
                >
                <v-btn
                  v-if="editorType == 'import'"
                  color="blue darken-1"
                  @click="openImportDialog"
                  small
                  text
                  >{{ $t("common.form.import") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.applyThrowToOverall="{ item }">
        {{ $t("common." + item.applyThrowToOverall) }}
      </template>
      <template v-slot:item.disableForSeries="{ item }">
        {{ $t("common." + item.disableForSeries) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small @click="confirmDelete(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <SGSNotificationConfirm
      v-if="dialogNotification"
      :notificationMessage="$t('common.confirm-delete')"
      @cancel="dialogNotification = false"
      @agree="deleteItem"
      type="warning"
      :acept="$t('common.form.delete')"
      :reject="$t('common.form.cancel')"
    />
    <SGSNotificationConfirm
      v-if="importDialogNotification"
      :notificationMessage="$t('page.series.confirm-import-series-classes')"
      @cancel="importDialogNotification = false"
      @agree="importClasses"
      type="warning"
      :acept="$t('common.form.import')"
      :reject="$t('common.form.cancel')"
    />
    <SGSNotificationAlert
      v-if="dialogAlert"
      :notificationMessage="alertMessage"
      @cancel="closeAlert"
      type="error"
    />
    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import { mapState } from "vuex";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationAlert from "@/components/custom/notification/NotificationAlert.vue";
import { TRUE_FALSE_OPTIONS } from "@/constants/selectOptions";

export default {
  mixins: [apiCalls],
  properties: [],
  components: {
    SGSNotificationConfirm,
    SGSNotificationAlert,
  },
  data() {
    return {
      input: {
        class: null,
        group: null,
        groupItems: [],
        applyThrowToOverall: null,
        disableForSeries: null,
        eventsToCount: null,
        sortOrder: null,
      },
      dialogNotification: false,
      importDialogNotification: false,
      alertMessage: "",
      dialogAlert: false,
      inputName: "",
      seriesModel: null,
      eventsModel: null,
      organizationModel: null,
      eventsItems: [],
      organizationItems: [],
      dialog: false,
      importDialog: true,
      reopenEdition: false,
      rows: [],
      item: {
        id: "",
        name: 0,
      },
      editorType: "new",
      importSeriesClassesFrom: 'series'
    };
  },
  computed: {
    ...mapState({
      seriesSelected: (state) => state.series.seriesSelected
    }),
    loading: {
        get(){
          return this.$store.state.loading;
        },
        set(val){
          this.$store.commit('TOGGLE_OVERLAY', val);
        }
    },
    formTitle() {
      let title = "";

      if (this.editorType == "new") title = this.$t("page.series.add-class");
      if (this.editorType == "edit") title = this.$t("page.series.edit-class");
      if (this.editorType == "import")
        title = this.$t("page.series.import-classes");

      return title;
    },
    eventsToCountRules: function () {
      const regInt = new RegExp("[0-9]+");
      return [
        (v) =>
          (v || "").toString().length > 0 ||
          (v != null && v.toString() == "0") ||
          this.$t("page.series.eventsToCount-required"),
        (v) => {
          const auxV = v ? v.toString() : "";
          const resultInt = auxV.split(regInt).filter((el) => el != "");
          return (
            !(resultInt.length > 0) ||
            this.$t("page.series.eventsToCount-invalid")
          );
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("page.series.class-name"),
          value: "className",
        },
        {
          text: this.$t("page.series.group-name"),
          value: "groupName",
        },
        {
          text: this.$t("page.series.throw-away"),
          value: "throwAways",
        },
        {
          text: this.$t("page.series.apply-throw-to-overall"),
          value: "applyThrowToOverall",
        },
        {
          text: this.$t("page.series.disable-for-series"),
          value: "disableForSeries",
        },
        {
          text: this.$t("page.series.events-to-count"),
          value: "eventsToCount",
        },
        {
          text: this.$t("page.series.sort-order"),
          value: "sortOrder",
        },
        {
          text: this.$t("common.table.actions"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    seriesItems() {
      if (!this.allSeries) {
        return [];
      }

      return this.allSeries
        .filter(series => series?.id && series.id !== this.seriesSelected?.id)
        .map(series => ({
          text: series.seriesName || '',
          value: series.id
        }))
        .sort((a, b) => b.value - a.value);
    },
    disableForSeriesItems() { return TRUE_FALSE_OPTIONS(this); }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    rows(val) {
      this.$emit('updateClasses', val);
    }
  },
  methods: {
    init()
    { 
      this.getRecords();
    },
    pressEnterDefaultZero($event,index) {
      if(($event.target.value || '').length == 0) {
        $event.preventDefault();
        this.input[index] = '0';
      }
    },
    pressEnter() {
      if (this.editorType == "edit") {
        this.save();
      } else if(this.editorType == 'create') {
        this.create();
      }
    },
    async getRecords() {
      if (this.seriesSelected) {
        const response = await this.api(
          "get",
          `/api/v1/promoter/series/${this.seriesSelected.id}/class`
        );

        this.getSeries();
        this.getGroups();

        this.rows = [];
        response.message.data.forEach((element, index) => {
          const row = {
            id: element.id,
            className: element.className,
            groupId: element.groupId,
            groupName: element.groupName,
            throwAways: element.throwAways,
            applyThrowToOverall: element.applyThrowToOverall == 1 ? true : false,
            disableForSeries: element.disableForSeries == 1 ? true : false,
            eventsToCount: element.eventsToCount,
            sortOrder: element.sortOrder,
            index: index,

            actions: "actions",
          };

          this.rows.push(row);
 
        });
    
      }
    },
    async getSeries() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi("/api/v1/promoter/series");
        this.allSeries = response ? response : [];
        this.loading = false;
      }
    },
    async getEvents() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi("/api/v1/promoter/series/class/import/events");

        response.message.sort(function(a, b) {
          return new Date(b.eventCreated) - new Date(a.eventCreated);
        });

        if (response != undefined) {
          for (var i = 0; i < response.message.length; i++) {
            this.eventsItems.push({
              text: response.message[i].eventName,
              value: response.message[i].id,
            });
          }
          this.loading = false;
        }else{
          this.loading = false;
        }
      }
    },
    async getOrganizations() {
      if (this.seriesSelected) {
        this.loading = true;
        const response = await this.getApi("/api/v1/promoter/series/class/import/organizations");

        if (response != undefined) {
          for (var i = 0; i < response.message.length; i++) {
            this.organizationItems.push({
              text: response.message[i].name,
              value: response.message[i].id,
            });
          }
          this.loading = false;
        }else{
          this.loading = false;
        }
      }
    },
    resetForm() {
      this.input.class = null;
      this.input.group = null;
      this.input.applyThrowToOverall = null;
      this.input.disableForSeries = null;
      this.input.eventsToCount = null;
      this.input.sortOrder = 0;
      this.input.throwAways = null;
      if (this.$refs.formSC) this.$refs.formSC.resetValidation();
    },
    setForm(item) {
      this.input.class = item.className;

      let group = null;
      if (item.groupName != null && item.groupId != null) {
        group = this.input.groupItems.find((el) => {
          return (
            el.text.trim().toLowerCase() == item.groupName.trim().toLowerCase()
          );
        });
      }
      this.input.group = group;
      this.input.applyThrowToOverall = Number(item.applyThrowToOverall);
      this.input.disableForSeries = Number(item.disableForSeries);
      this.input.eventsToCount = item.eventsToCount;
      this.input.sortOrder = !item.sortOrder ? 0 : item.sortOrder;
      this.input.throwAways = item.throwAways;
      this.input.id = item.id;
      this.input.index = item.index;
    },
    newItem() {
      this.resetForm();
      this.inputName = "";
      this.editorType = "new";
    },
    importItem() {
      if (this.$refs.formSC) this.$refs.formSC.resetValidation();
      this.resetForm();
      this.editorType = "import";
      this.dialog = true;
    },
    editItem(item) {
      this.resetForm();
      this.setForm(item);
      this.editorType = "edit";
      this.dialog = true;
      this.inputName = item.name;
      this.item.id = item.id;
      if (this.$refs.formSC) this.$refs.formSC.resetValidation();
    },
    confirmDelete(item) {
      this.dialogNotification = true;
      this.item = item;
    },
    async deleteItem()
    {
      const response = await this.api(
        "DELETE",
        `/api/v1/promoter/series/class/${this.item.id}`
      );
      if (!response || !response.success)
      {
        this.alertMessage = this.$t('page.series.error_general');
        if (Array.isArray(response.error) && response.error.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.error[0]);
        } else if (typeof response.error == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.error)
        } else if (Array.isArray(response.message) && response.message.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.message[0]);
        } else if (typeof response.message == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.message)
        }
        this.dialog = false;
        this.dialogAlert = true;
        return;
      }
      this.getRecords();
      this.close();
    },
    close() {
      this.dialog = false;
      this.dialogNotification = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async create()
    {
      if (this.$refs.formSC.validate())
      {
        if (this.input.disableForSeries == null)
        {
          this.$refs.disableForSeriesItems.focus();
          return false;
        }

        let data = {};
        data.seriesId = this.seriesSelected.id;
        data.applyThrowToOverall = this.input.applyThrowToOverall;
        data.disableForSeries = this.input.disableForSeries;
        data.groupId = this.input.group;
        data.throwAways = this.input.throwAways;
        data.eventsToCount = this.input.eventsToCount;
        data.className = this.input.class;
        data.sortOrder = this.input.sortOrder;

        const response = await this.api(
          "POST",
          "/api/v1/promoter/series/class",
          data
        );

        if (!response || !response.success)
        {
          this.alertMessage = this.$t('page.series.error_general');
          if (Array.isArray(response.error) && response.error.length > 0)
          {
            this.alertMessage = this.$t('common.request.' + response.error[0]);
          } else if (typeof response.error == 'string')
          {
            this.alertMessage = this.$t('common.request.' + response.error)
          } else if (Array.isArray(response.message) && response.message.length > 0)
          {
            this.alertMessage = this.$t('common.request.' + response.message[0]);
          } else if (typeof response.message == 'string')
          {
            this.alertMessage = this.$t('common.request.' + response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true;
          return;
        }
        this.getRecords();
        this.close();
      }
    },
    openImportDialog(){
      const importType = this.importSeriesClassesFrom;
      
      if (!this.$refs.formSC.validate()) {
        if ((this.seriesModel == null || this.seriesModel == "") && importType == 'series') {
          this.importDialogNotification = false;
          this.$refs.selectSeriesInput.focus();
          return false;
        } else if ((this.eventsModel == null || this.eventsModel == "") && importType == 'events') {
          this.importDialogNotification = false;
          this.$refs.selectEventsInput.focus();
          return false;
        } else if ((this.seriesModel == null || this.seriesModel == "") && importType == 'organization') {
          this.importDialogNotification = false;
          this.$refs.selectOrganizationInput.focus();
          return false;
        }
        return;
      }
      this.dialog = false;
      this.importDialogNotification = true;
    },
    async importClasses() {
      const importType = this.importSeriesClassesFrom

      //console.log('this.$refs.formSC.validate()',this.$refs.formSC.validate());
      if (!this.$refs.formSC.validate()) {
        if ((this.seriesModel == null || this.seriesModel == "") && importType == 'series') {
          this.$refs.selectSeriesInput.focus();
          return false;
        } else if ((this.eventsModel == null || this.eventsModel == "") && importType == 'events') {
          this.$refs.selectEventsInput.focus();
          return false;
        } else if ((this.seriesModel == null || this.seriesModel == "") && importType == 'organization') {
          this.$refs.selectOrganizationInput.focus();
          return false;
        }
        return;
      }
      this.importDialogNotification = false;
      
      const method = 'POST';
      let link = '/wrong-link-generation';
      let data = {
        /** current Serie */
        seriesId: this.seriesSelected.id,
        eventsToCount: this.input.eventsToCount ? this.input.eventsToCount : 0,
        throwAway: this.input.throwAways ? this.input.throwAways : 0
      }

      switch (importType){
        case 'series':
          link = '/api/v1/promoter/series/class/import';
          data.targetSeriesId = this.seriesModel;
          break;

        case 'events':
          link = '/api/v1/promoter/series/class/import/events';
          data.targetEventsId = this.eventsModel;
          break;

        case 'organization':
          link = '/api/v1/promoter/series/class/import/organization';
          data.targetOrganizationId = this.organizationModel;
          break;
      }

      const response = await this.api(
        method,
        link,
        data
      );

      if(!response || !response.success){ 
          this.alertMessage = this.$t('page.series.error_general');
          if(response && Array.isArray(response.error) && response.error.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.error[0]);
          } else if(response && typeof response.error == 'string') {
              this.alertMessage = this.$t('common.request.'+response.error)
          } else if(response && Array.isArray(response.message) && response.message.length > 0) {
              this.alertMessage = this.$t('common.request.'+response.message[0]);
          } else if(response && typeof response.message == 'string') {
              this.alertMessage = this.$t('common.request.'+response.message)
          }
          this.dialog = false;
          this.dialogAlert = true;
          this.reopenEdition = true;
          return; 
      }
      this.getRecords();
      this.close();
    },
    async save()
    {
      if (!this.$refs.formSC.validate())
      {
        return;
      }

      let data = {};
      data.id = this.input.id;
      data.applyThrowToOverall = this.input.applyThrowToOverall;
      data.disableForSeries = this.input.disableForSeries;
      if (this.input.group instanceof Object)
      {
        data.groupId = this.input.group.value;
      } else
      {
        data.groupId = this.input.group;
      }
      data.throwAways = this.input.throwAways;
      data.eventsToCount = this.input.eventsToCount;
      data.className = this.input.class;
      data.sortOrder = this.input.sortOrder;

      const response = await this.api(
        "PUT",
        "/api/v1/promoter/series/class",
        data
      );

      if (!response || !response.success)
      {
        this.alertMessage = this.$t('page.series.error_general');
        if (Array.isArray(response.error) && response.error.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.error[0]);
        } else if (typeof response.error == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.error)
        } else if (Array.isArray(response.message) && response.message.length > 0)
        {
          this.alertMessage = this.$t('common.request.' + response.message[0]);
        } else if (typeof response.message == 'string')
        {
          this.alertMessage = this.$t('common.request.' + response.message)
        }
        this.dialog = false;
        this.dialogAlert = true;
        this.reopenEdition = true;
        return;
      }
      this.getRecords();
      this.close();

    },
    closeAlert() {
      this.dialogAlert = false;
      if (this.reopenEdition) {
        this.dialog = true;
      }
    },
    async getGroups() {
      if (this.seriesSelected) {
        const response = await this.api(
          "get",
          `/api/v1/promoter/series/group/${this.seriesSelected.id}`
        );

        this.input.groupItems = [];
        const item = {
          value: null,
          text: this.$t("page.series.group-name-none"),
        };
        this.input.groupItems.push(item);
        response.message.data.forEach((element) => {
          const item = { value: element.id, text: element.groupName };
          this.input.groupItems.push(item);
        });
      }
    },
  },
};
</script>

<style scoped>
.v-application .headline {
  font-size: 24px !important;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0 40px 20px;
}
.v-card__actions .v-btn {
  background-color: var(--v-primary-darken2) !important;
  color: white !important;
}
.v-text-field.v-text-field--enclosed {
    padding-top: 12px;
    margin-top: 4px;
}
</style>

